class SlideoutGifting extends HTMLElement {
  constructor() {
    super();

    this.giftingDrawer = this;
    if (!this.giftingDrawer) return;

    this.overlay = this.querySelector('[data-gifting-overlay]');
    this.closeButton = this.querySelector('[data-gifting-close]');
    this.form = this.querySelector('[data-gifting-form]');
  }

  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    // Use event delegation on the cart element which exists on page load
    console.log('slideout-gifting', document.querySelector('[data-slideout-cart]'));
    document.querySelector('[data-slideout-cart]')?.addEventListener('click', (e) => {
      const giftToggleButton = e.target.closest('.slideout-cart__gift-toggle-button');
      console.log('giftToggleButton', giftToggleButton);
      if (giftToggleButton) {
        this.giftingDrawer.classList.add('is-active');
      }
    });

    // Close handlers
    this.closeButton?.addEventListener('click', () => {
      this.giftingDrawer.classList.remove('is-active');
    });

    this.overlay?.addEventListener('click', () => {
      this.giftingDrawer.classList.remove('is-active');
    });

    // Form submission
    this.form?.addEventListener('submit', (e) => {
      e.preventDefault();

      const formData = new FormData(this.form);
      const giftData = {
        name: formData.get('recipient_name'),
        email: formData.get('recipient_email'),
        date: formData.get('delivery_date'),
        message: formData.get('gift_message'),
      };

      // Store gift data as a cart attribute
      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          attributes: {
            _giftRecipient: JSON.stringify(giftData),
          },
        }),
      }).then(() => {
        this.giftingDrawer.classList.remove('is-active');
        // Optionally refresh the cart display
        window.slideoutCart?.fetchCart();
      });
    });
  }
}

// Register the custom element
customElements.define('slideout-gifting', SlideoutGifting);
